export const enum ActiveStep {
    ReportName = 'report-name',
    ReportType = 'report-type',
    VisibleColumns = 'visible-columns',
    Filters = 'filters',
}
